export type ErrorPayload = any;

export const extractErrorPayload = async (err: any): Promise<ErrorPayload> => {
  if (err?.response?.data !== undefined) return err.response.data;

  if (typeof Response !== 'undefined' && err instanceof Response) {
    const res = err as Response;
    try {
      const text = await res.clone().text();
      if (!text) {
        return {
          message: '',
          status: res.status,
          statusText: res.statusText,
          url: res.url,
        };
      }
      try {
        return JSON.parse(text);
      } catch {
        return { message: text, status: res.status, statusText: res.statusText, url: res.url };
      }
    } catch {
      return { message: res.statusText || 'Request failed', status: res.status, url: res.url };
    }
  }

  if (err?.body) return err.body;

  return err ?? { message: 'Unknown error' };
};